/* esm.sh - preact@10.29.1 */
export * from "/*preact@10.29.1/esnext/preact.mjs";
